import React from 'react';

interface LiveContextProps {
  displayId: string | null;
  setDisplayId: (displayId: string | null) => void;
  search: string | null;
  setSearch: (search: string | null) => void;
}

export const LiveContext = React.createContext<LiveContextProps>({
  displayId: null,
  setDisplayId: () => { },
  search: null,
  setSearch: () => { },
});

export function LiveContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [displayId, setDisplayId] = React.useState<string | null>(null);
  const [search, setSearch] = React.useState<string | null>(null);

  const value = React.useMemo(() => ({
    displayId,
    setDisplayId,
    search,
    setSearch,
  }), [search, displayId]);
  return (
    <LiveContext.Provider value={value}>
      {children}
    </LiveContext.Provider>
  );
}

export default function useLiveContext() {
  const context = React.useContext(LiveContext);
  if (!context) {
    const error = new Error('useLiveContext must be used within a LiveContextProvider');
    console.error(error);
    throw error;
  }
  return context;
}
